var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C10.09 13 13 10.09 13 6.5ZM4 6.5C4 5.12156 5.12156 4 6.5 4C7.87844 4 9 5.12156 9 6.5C9 7.87844 7.87844 9 6.5 9C5.12156 9 4 7.87844 4 6.5ZM8 6.5C8 5.67156 7.32844 5 6.5 5C5.67156 5 5 5.67156 5 6.5C5 7.32844 5.67156 8 6.5 8C7.32844 8 8 7.32844 8 6.5ZM14.5 10C13.6716 10 13 10.6716 13 11.5C13 12.0134 13.2584 12.4653 13.6519 12.7359C13.4619 13.1844 13.0172 13.5 12.5 13.5H11V12.4856C9.74469 13.4319 8.18937 14 6.5 14C4.81063 14 3.25531 13.4319 2 12.4856V15C2 15.5522 2.44781 16 3 16H10C10.5522 16 11 15.5522 11 15H12.5C13.8188 15 14.9213 14.0666 15.1869 12.8263C15.6678 12.5763 16 12.0794 16 11.5C16 10.6716 15.3284 10 14.5 10Z",
    fill: "#786D6C",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleType);
export default __webpack_public_path__ + "static/media/schedule_type.b9466ed5d6b6fabf3455f7c7c7b15dd1.svg";
export { ForwardRef as ReactComponent };